import { push } from 'react-router-redux';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clearToken, getToken, setToken } from '../../helpers/utility';
import AuthHelper from '../../helpers/authHelper';
import actions from './actions';
import notification from '../../components/notification';

export function* loginRequest() {
	yield takeEvery('LOGIN_REQUEST', function* ({ payload, props }) {
		const { userInfo } = payload;
		const result = yield call(AuthHelper.login, userInfo);
		if (result.error !== undefined) {
			notification('warning', "Aviso", result.error);
			yield put({ type: actions.LOGIN_ERROR });
		}
		else {
			yield put({
				type: actions.LOGIN_SUCCESS,
				payload: result, // Não tem muita lógica visto que será apenas o token, futuramete iremos armazenar expiração do token.
				token: result,//.token,
				props: props
			});
		}
	});
}

export function* loginSuccess() {
	yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
		yield setToken(payload.token); // É exatamente o mesmo que "yield localStorage.setItem('token', payload.token);"
		if (typeof payload.props != "undefined") {
			payload.props.history.push('/dashboard/Home');
		}
	});
}

export function* loginError() {
	yield takeEvery(actions.LOGIN_ERROR, function* () { });
}

export function* logout() {
	yield takeEvery(actions.LOGOUT, function* () {
		clearToken();
		localStorage.removeItem('ticketCredentials');
		localStorage.removeItem('googleOtherDocuments');
		localStorage.removeItem('googleShippings');
		localStorage.removeItem('googleTreeFolder');
		localStorage.removeItem('OhterDocsMonthYear');
		localStorage.removeItem('ShippingMonthYear');
		document.location.reload(true);
		yield put(push('/'));
	});
}

export function* checkAuthorization() {
	yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
		const token = getToken(); // Deveríamos validar se já expirou. | AuthHelper.checkExpirity(getToken());

		if (token) {
			yield put({
				type: actions.LOGIN_SUCCESS,
				payload: { token },
				token,
			});

			// yield put(push('/dashboard/Home')); // Redirecionar para a Dashboard
		}
	});
}

export function* setGoogleOtherDocs() {
	yield takeEvery(actions.GOOGLE_OTHERDOCS, function* (payload) {
		var str = JSON.stringify(payload);
		localStorage.setItem('googleOtherDocs', str);
	});
}

export function* getGoogleOtherDocs() {
	yield takeEvery(actions.GET_GOOGLE_OTHERDOCS, function* () {
		var str = localStorage.getItem('googleOtherDocs', str);
		var obj = JSON.parse(str);
		return obj;
	});
}

export function* clearGoogleOtherDocs() {
	yield takeEvery(actions.CLEAR_GOOGLE_OTHERDOCS, function* () {
		localStorage.removeItem('googleOtherDocs');
	});
}

export default function* rootSaga() {
	yield all([
		fork(checkAuthorization),
		fork(loginRequest),
		fork(loginSuccess),
		fork(loginError),
		fork(logout)
	]);
}
